var React = require('react');

function SlideRight (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"1","width":"30","height":"50","fill":"white","key":0}),React.createElement("path",{"d":"M17.72 25.314L12.679 20.214C12.305 19.836 12 19.962 12 20.498V31.498C12 32.034 12.3 32.16 12.679 31.782L17.72 26.682C17.8986 26.4991 17.9986 26.2536 17.9986 25.998C17.9986 25.7424 17.8986 25.4969 17.72 25.314Z","fill":"#ADADAD","key":1})]);
}

SlideRight.defaultProps = {"width":"30","height":"50","viewBox":"0 0 30 50","fill":"none"};

module.exports = SlideRight;

SlideRight.default = SlideRight;
